import { ViewTitleProps } from '@diligentcorp/heracles-view-title';
import { LoadingButtonProps } from '@issuemanager/apps/client/components';
import React from 'react';
import { create } from 'zustand';

export type AppHeaderPrimaryButtonProps = LoadingButtonProps & {
  'data-testid'?: string;
};

export interface AppHeaderProps {
  viewTitle: ViewTitleProps;
  buttons?: AppHeaderPrimaryButtonProps[];
  chip?: React.ReactNode;
  bottomSection?: React.ReactNode;
}

interface AppHeaderStoreProps {
  headerProps: AppHeaderProps;
  setHeaderProps: (headerProps: AppHeaderProps) => void;
}

export const useHeaderStore = create<AppHeaderStoreProps>((set) => ({
  // original state
  headerProps: {
    viewTitle: {
      title: '',
    },
    buttons: [],
    chip: undefined,
    bottomSection: null,
  },
  setHeaderProps: (headerProps) => set({ headerProps }),
}));
